const providerToClientServiceName = {
  'Montador de móveis': 'Montagem de móveis',
  'Instalador de eletrodomésticos': 'Instalação de eletrodomésticos',
} as {
  [key: string]: string;
}

export const parseServiceName = (serviceName: string) => {
  return providerToClientServiceName[serviceName] || serviceName;
}
